import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CEUIExitButton from 'ContentEditorUI/components/header/ExitButton';
import useFromPersonalizationParam from 'personalization-lib/hooks/nav/useFromPersonalizationParam';
import PersonalizationLink from 'personalization-lib/components/buttons/PersonalizationLink';
import { getContentModelPersonalizationStrategyId } from '../redux/selectors/pageContentModelSelectors';
// @ts-expect-error not typed yet
import { getDashboardUrl } from '../redux/selectors/urlSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExitButton = ({
  isUsingPersonalization,
  buttonSize = 'small'
}) => {
  const dashboardUrl = useSelector(getDashboardUrl);
  const personalizationStrategyIdFromQueryParams = useFromPersonalizationParam();
  const personalizationStrategyIdFromContentModel = useSelector(getContentModelPersonalizationStrategyId);
  const shouldShowPersonalizationLink = useMemo(() => {
    if (isUsingPersonalization && personalizationStrategyIdFromQueryParams && personalizationStrategyIdFromContentModel) {
      return personalizationStrategyIdFromQueryParams === Number(personalizationStrategyIdFromContentModel);
    }
    return false;
  }, [isUsingPersonalization, personalizationStrategyIdFromQueryParams, personalizationStrategyIdFromContentModel]);
  if (shouldShowPersonalizationLink) {
    return /*#__PURE__*/_jsx(PersonalizationLink, {
      strategyId: personalizationStrategyIdFromQueryParams,
      use: "secondary-ghost",
      size: buttonSize
    });
  }
  return /*#__PURE__*/_jsx(CEUIExitButton, {
    size: buttonSize,
    dashboardUrl: dashboardUrl
  });
};